function RetentionList(props) {

    return (<>Coming Soon Retention</>)
}

export default RetentionList;